import React, { useState, useEffect, useCallback } from 'react';
import { api } from '../api';
import { Modal } from './shared';

// Naviga le cartelle di OneDrive a partire dalla radice (o da un punto di partenza)
export default function SelettoreCartella({ inizio = '', titolo = 'Scegli cartella OneDrive', onScegli, onClose }) {
  const [percorso, setPercorso] = useState(inizio);
  const [cartelle, setCartelle] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errore, setErrore] = useState('');
  const [filtro, setFiltro] = useState('');

  const carica = useCallback((p) => {
    setLoading(true); setErrore('');
    api.get('/api/onedrive-cartelle?path=' + encodeURIComponent(p))
      .then(d => setCartelle(d.cartelle || []))
      .catch(e => { setCartelle([]); setErrore(e.message); })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { carica(percorso); setFiltro(''); }, [percorso, carica]);

  const aggiorna = async () => {
    try { await api.post('/api/onedrive-cartelle/aggiorna', {}); } catch (e) { /* ignora */ }
    carica(percorso);
  };

  const parti = percorso ? percorso.split('/') : [];
  const visibili = cartelle.filter(c => c.nome.toLowerCase().includes(filtro.toLowerCase()));

  return (
    <Modal title={titolo} onClose={onClose}>
      <div style={{ display:'flex', alignItems:'center', gap:6, flexWrap:'wrap', marginBottom:10, fontSize:13 }}>
        <button className="btn btn-sm" onClick={() => setPercorso('')}>☁ OneDrive</button>
        {parti.map((p, i) => (
          <React.Fragment key={i}>
            <span style={{ color:'var(--text-faint)' }}>/</span>
            <button className="btn btn-sm" onClick={() => setPercorso(parti.slice(0, i + 1).join('/'))}>{p}</button>
          </React.Fragment>
        ))}
        <button className="btn btn-sm" style={{ marginLeft:'auto' }} onClick={aggiorna} title="Rilegge le cartelle da OneDrive">↻</button>
      </div>

      <input className="form-control" placeholder="Filtra cartelle…" value={filtro}
        onChange={e => setFiltro(e.target.value)} style={{ marginBottom:10 }} autoFocus />

      <div style={{ border:'1px solid var(--border)', borderRadius:'var(--radius-sm)', maxHeight:320, overflowY:'auto' }}>
        {loading && <div style={{ padding:20, textAlign:'center', color:'var(--text-faint)' }}>⏳ Caricamento…</div>}
        {!loading && errore && <div style={{ padding:16, color:'#DC2626', fontSize:13 }}>⚠ {errore}</div>}
        {!loading && !errore && visibili.length === 0 && (
          <div style={{ padding:20, textAlign:'center', color:'var(--text-faint)', fontSize:13 }}>Nessuna sottocartella</div>
        )}
        {!loading && visibili.map(c => (
          <div key={c.percorso} style={{ display:'flex', alignItems:'center', gap:8, padding:'7px 12px', borderBottom:'1px solid var(--border)' }}>
            <span onClick={() => setPercorso(c.percorso)} style={{ flex:1, cursor:'pointer', fontSize:13.5 }}>📁 {c.nome}</span>
            <button className="btn btn-sm" onClick={() => onScegli(c.percorso)}>Scegli</button>
          </div>
        ))}
      </div>

      <div className="modal-footer" style={{ padding:'14px 0 0', marginTop:12, borderTop:'1px solid var(--border)' }}>
        <span style={{ marginRight:'auto', fontSize:12, color:'var(--text-faint)' }}>
          {percorso ? <>Cartella aperta: <b>{percorso}</b></> : 'Radice di OneDrive'}
        </span>
        <button className="btn" onClick={onClose}>Annulla</button>
        {percorso && <button className="btn btn-primary" onClick={() => onScegli(percorso)}>✓ Scegli questa cartella</button>}
      </div>
    </Modal>
  );
}
